module.exports = __webpack_public_path__ + "img/right-baner.8bc9a8f4.png";